export function formatVND(amount: number): string {
  if (amount === 0) return '0đ'
  const formatted = Math.abs(amount)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  return amount < 0 ? `-${formatted}đ` : `${formatted}đ`
}

export function formatVNDCompact(amount: number): string {
  if (amount >= 1_000_000_000) {
    return `${(amount / 1_000_000_000).toFixed(1).replace('.0', '')} tỷ`
  }
  if (amount >= 1_000_000) {
    return `${(amount / 1_000_000).toFixed(1).replace('.0', '')}M`
  }
  if (amount >= 1_000) {
    return `${(amount / 1_000).toFixed(0)}K`
  }
  return formatVND(amount)
}

export function formatPhone(phone: string): string {
  const cleaned = phone.replace(/\D/g, '')
  if (cleaned.length === 10) {
    return `${cleaned.slice(0, 4)} ${cleaned.slice(4, 7)} ${cleaned.slice(7)}`
  }
  return phone
}

export function formatDate(dateStr: string): string {
  const date = new Date(dateStr)
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear()
  return `${day}/${month}/${year}`
}

export function formatDateTime(dateStr: string): string {
  const date = new Date(dateStr)
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear()
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  return `${day}/${month}/${year} ${hours}:${minutes}`
}

export function formatRelativeTime(dateStr: string): string {
  const now = new Date()
  const date = new Date(dateStr)
  const diffMs = now.getTime() - date.getTime()
  const diffMins = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMs / 3600000)
  const diffDays = Math.floor(diffMs / 86400000)

  if (diffMins < 1) return 'Vừa xong'
  if (diffMins < 60) return `${diffMins} phút trước`
  if (diffHours < 24) return `${diffHours} giờ trước`
  if (diffDays < 7) return `${diffDays} ngày trước`
  if (diffDays < 30) return `${Math.floor(diffDays / 7)} tuần trước`
  return formatDate(dateStr)
}

export function isValidDepositAmount(amount: number): boolean {
  return amount > 0 && amount % 10_000_000 === 0
}

export function calculateBonus(
  amount: number,
  bonusPercent: number = 2.5,
): number {
  return Math.floor(amount * (bonusPercent / 100))
}

export function getTierFromPoints(
  points: number,
): 'member' | 'silver' | 'gold' | 'vip' {
  if (points >= 15000) return 'vip'
  if (points >= 5000) return 'gold'
  if (points >= 1000) return 'silver'
  return 'member'
}

export function getTierNameVi(tier: string): string {
  const names: Record<string, string> = {
    member: 'Thành Viên',
    silver: 'Bạc',
    gold: 'Vàng',
    vip: 'VIP',
  }
  return names[tier] || tier
}

export function getTierColor(tier: string): string {
  const colors: Record<string, string> = {
    member: '#666666',
    silver: '#A0AEC0',
    gold: '#C8A84E',
    vip: '#EF4444',
  }
  return colors[tier] || '#666666'
}

export function generateReferralCode(name: string): string {
  const prefix = name.split(' ').pop()?.toUpperCase().slice(0, 3) || 'MHP'
  const suffix = Math.random().toString(36).substring(2, 6).toUpperCase()
  return `${prefix}${suffix}`
}
